module.exports = __webpack_public_path__ + "img/visa-small-icon.2ab43641.svg";